import Filter from '@/components/modal-select/filters/Filter.js';

export default class TagFilter extends Filter {
    constructor(field, label) {
        super(field, label);

        this.type = 'tags';

        this.handler = async ({ filterEvent }) => {
            const value = filterEvent.getAttribute('value');

            if (!value) {
                this.queryBuilder.removeRaw('tags');
            } else {
                this.queryBuilder.raw({ tags: value });
            }
        };
    }

    clearFilter() {
        this.queryBuilder.removeRaw('tags');
    }

    get is_applied() {
        return Boolean(this.queryBuilder.hasRaw(this.field));
    }
}
